// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2YEuc","title":"Header_title__3LI3d","left":"Header_left__xFs4h","clinicName":"Header_clinicName__1_duM"};